import React from 'react'
import MyRefetchButton from 'components/ui/MyRefetchButton'
import TemplateCreate from 'components/template-create'

const DataTableToolbar = ({ mutate }) => {
  return (
    <div className="flex items-center justify-between my-4">
      <MyRefetchButton onClick={() => mutate()} />
      <TemplateCreate mutate={mutate} />
    </div>
  )
}

export default DataTableToolbar
